<template>
  <div class="container">

    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :bilan-type="bilanType" :params="{operationId: operationId}"
                  :title="$t('operation.investor.title')"
                  :sub-title-ope="operationName"
                  routeBack="OperationShow"/>
      <div class="row mx-0 ml-auto align-items-center">
        <b-button v-if="contrats.length > 0" class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ $t('investor') }}
        </b-button>
      </div>
    </div>

    <b-row v-if="contrats.length === 0" align-h="center" class="row mt-4 mx-0">
      <div class="col-md-5 text-center">
        <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="mt-4 mb-2 no-result-img"
             style="max-height: 25%;">

        <div class="main-color-text-text bold-text level-two-title">
          {{ $t('operation.investor.emptyTitle') }}
        </div>

        <div class="main-color-text">
          {{ $t('operation.investor.emptySubtitle.first') }}
        </div>

        <b-button class="my-2" variant="primary" @click="clickOnCreateBtn">
          {{ $t('operation.investor.create') }}
        </b-button>
      </div>
    </b-row>
    <div v-else>
      <div class="row mx-0 mt-4 mb-3 justify-content-between">
      </div>

      <div class="col-md-6">
        <draggable :list="contrats" class="draggable-list" group="contrats">
          <div v-for="element in contrats" :key="element.name" class="list-item">
            <div class="d-flex investor mb-1 mx-0">
              <menu-2-icon size="18"></menu-2-icon>
              <span class="ml-2"> {{ element.name }} </span>
              <span class="ml-auto"> {{ getPrixEuros(element.initialPayment) }} </span>
            </div>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";
import draggable from 'vuedraggable';
import BackArrow from "../../../components/b122/BackArrow.vue";

export default {
  name: "OperationShowInvestor",

  components: {
    BackArrow,
    draggable
  },

  async mounted() {
    await this.fetchData()
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      isLoading: false,
      contrats: [],
      bilanType: null,
      operationName: null
    }
  },


  watch: {
    'contrats': function () {
      this.updatePriorities()
    },
  },

  methods: {
    async fetchData() {
      await this.fetchInvestorContrats()
      await this.getOperation()
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.bilanType = response.data.bilanType
            this.operationName = response.data.name
          })
      }
    },

    async fetchInvestorContrats() {
      this.isLoading = true
      api
        .get(`/investorContrat/getAllForOperation/${this.operationId}`)
        .then(response => {
          response.data.forEach(contrat => {
            this.contrats.push({
              id: contrat.id,
              name: contrat.name,
              priority: contrat.priority,
              initialPayment: contrat.initialPayment,
            })
          })
          this.isLoading = false
        })
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'InvestorContratCreateEdit',
        params: {
          investorContratId: null,
          operationId: this.operationId
        }
      })
    },

    updatePriorities() {
      let form = new FormData()
      form.append("contrats", JSON.stringify(this.contrats))
      form.append("operationId", JSON.stringify(this.operationId))
      api({
        method: 'POST',
        url: '/investorContrat/updatePriorities',
        data: form
      })
    },

    getPrixEuros(prix) {
      return Intl.NumberFormat().format((prix / 100).toFixed(0)) + '€'
    }
  }
}

</script>

<style scoped>

.investor {
  border-radius: 2px;
  border: solid 1px var(--main-grey);
  padding: 8px;
}

.list-item {
  background-color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowInvestor.vue